(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-lg-gallery]').forEach(root => {
      if (root.dataset.lgGalleryReady) return;
      const buttons = [...root.querySelectorAll('[data-lg-gallery-tab]')];
      const panels = [...root.querySelectorAll('[data-lg-gallery-panel]')];
      if (!buttons.length || !panels.length) return;
      root.dataset.lgGalleryReady = 'true';
      const controls = root.querySelector('[data-lg-gallery-controls]');
      controls.hidden = false; controls.setAttribute('role', 'tablist');
      function select(button, focus = false) {
        const key = button.dataset.lgGalleryTab;
        buttons.forEach(item => { const active = item === button; item.setAttribute('role','tab'); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.dataset.lgGalleryPanel !== key; panel.setAttribute('role','tabpanel'); });
        if (focus) button.focus();
      }
      buttons.forEach((button,index) => {
        button.addEventListener('click',() => select(button));
        button.addEventListener('keydown',event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== undefined) { event.preventDefault(); select(buttons[next], true); }
        });
      });
      select(buttons[0]);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
